import { useLanguage } from "@/contexts/LanguageContext";
import { DemoSharedLog } from "./DemoSharedLog";

export function SharedLogSection() {
  const { t } = useLanguage();

  return (
    <section className="landing-section-dark py-12 sm:py-14">
      <div className="max-w-5xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-7 gap-8 items-start">
          {/* Text - Left side */}
          <div className="lg:col-span-2 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              {t("landing.sharedLog.headline")}
            </h2>
            <p className="text-sm text-white/70 leading-relaxed">
              {t("landing.sharedLog.description")}
            </p>
          </div>

          {/* Demo Log - Right side */}
          <div className="lg:col-span-5">
            <DemoSharedLog />
          </div>
        </div>
      </div>
    </section>
  );
}
